import { useState, type FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth-context";

export function Register() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await auth.register(email, password, fullName || undefined);
      navigate("/carte", { replace: true });
    } catch (e) {
      setError((e as Error).message ?? "Erreur inconnue");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>🧭 Nouveau compte</h1>
        <p className="auth-sub">Crée ton compte organisateur.</p>
        <form onSubmit={onSubmit}>
          <label>
            Nom complet
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              autoComplete="name"
            />
          </label>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </label>
          <label>
            Mot de passe (8+ caractères)
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              required
              minLength={8}
            />
          </label>
          {error && <p className="auth-error">✗ {error}</p>}
          <button type="submit" disabled={submitting}>
            {submitting ? "Création..." : "Créer mon compte"}
          </button>
          <p className="auth-alt">
            Déjà un compte ? <Link to="/login">Connecte-toi</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
